/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import { CUSTOMIZABLE_COLUMNS } from '@engine/actions/action-types';
/**
 * Action Creators for Custom Export Modal
 */

export var resetForm = function resetForm(preference, data) {
  return {
    type: CUSTOMIZABLE_COLUMNS(preference).resetPreference,
    data: data
  };
};
export var handleResponse = function handleResponse(preference, data) {
  return {
    type: CUSTOMIZABLE_COLUMNS(preference).responseReceive,
    data: data
  };
};
export var preferencesUpdate = function preferencesUpdate(preference, data) {
  return {
    type: CUSTOMIZABLE_COLUMNS(preference).updateSelectedPreferences,
    data: data
  };
};
export var submitFail = function submitFail(preference) {
  return {
    type: CUSTOMIZABLE_COLUMNS(preference).requestFail
  };
};
export var submitRequest = function submitRequest(preference) {
  return {
    type: CUSTOMIZABLE_COLUMNS(preference).requestInProgress
  };
};
/**
 * Submit Form
 */

export function updateCustomizableColumns(url, preference) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'PUT';
  return function (dispatch, getState) {
    dispatch(submitRequest(preference));
    var preferences = getState()["columns-for-".concat(preference)].selectedFields;
    var formData = {
      authenticity_token: window.CSRF,
      selected_preferences: preferences
    };
    return fetch(url, {
      method: method,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      return dispatch(handleResponse(preference, json));
    })["catch"](function () {
      return dispatch(submitFail(preference));
    });
  };
}